import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { OfflineService } from '@evorait/pace-offline';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { catchError, exhaustMap, mergeMap, take, tap } from 'rxjs/operators';
import { ClientManagerInstanceToken, ClientManagerInterface } from '../../interfaces/client-manager.interface';
import { EmailLogService } from '../../services/email-log/email-log.service';
import { LocalStorageCommonService } from '../../services/local-storage/local-storage-common.service';
import { ReportIssueService } from '../../services/report-issue/report-issue.service';
import { ReportIssueModel } from './report-issue.model';
import { ConfigService } from '../../services/config/config.service';

@Component({
    selector: 'pace-core-report-issue',
    templateUrl: './report-issue.component.html',
    styleUrls: ['./report-issue.component.scss'],
})
export class ReportIssueComponent implements OnInit {
    @Input()
    public model: ReportIssueModel;
    public isNgmP58: boolean;

    public formChildren: FormArray;
    public reportIssueForm: FormGroup;

    private submitErrorReport = new Subject<void>();
    public allowedMimeTypes: string[];

    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly emailLogService: EmailLogService,
        private readonly localStorageCommonService: LocalStorageCommonService,
        public readonly modalInstance: BsModalRef,
        private readonly formBuilder: FormBuilder,
        private readonly reportIssueService: ReportIssueService,
        private readonly offlineService: OfflineService,
        private readonly configService: ConfigService,
        @Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface,
    ) {
        this.isNgmP58 = this.clientManager.isNgmP58();
        this.allowedMimeTypes = this.configService.defaultAllowedMimeTypes;
        if (configService.isInitialized) {
            this.allowedMimeTypes = this.configService.getReportAnIssueAllowedMimeTypes();
        }
    }

    public ngOnInit(): void {
        this.formChildren = this.formBuilder.array([]);
        this.reportIssueForm = this.formBuilder.group({
            children: this.formChildren,
            files: [null],
        });
        this.submitErrorReport
            .asObservable()
            .pipe(
                take(1),
                tap(() => {
                    // print local storage usage when sending an error report
                    this.log.debug('LocalStorage usage:');
                    this.localStorageCommonService.printConsumedLocalStorageSize();
                    this.modalInstance.hide();
                }),
                mergeMap(() => this.offlineService.addPendingRequestsTextToLogs()),
                exhaustMap(() => this.reportIssueService.createSharpIncident(this.model)),
                catchError((error) => {
                    this.log.error(`[ReportIssueComponent]: ${error}`);
                    return this.emailLogService.sendEmailLog(this.reportIssueService.getEmailBody(this.model));
                }),
            )
            .subscribe();
    }

    public onFileSelected(files: File[]): void {
        this.model.files = files;
    }

    public submitData(): void {
        this.submitErrorReport.next();
    }
}
